import React from 'react';
import { Facebook } from 'lucide-react';
export function Footer() {
  const legalLinks = ['Politica de Confidențialitate', 'Termeni și Condiții', 'Politica Cookies', 'GDPR'];
  return <footer className="bg-white py-12" data-id="element-114">
      <div className="max-w-[1180px] mx-auto px-6" data-id="element-115">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-116">
          {/* Brand */}
          <div className="space-y-4" data-id="element-117">
            <h3 className="font-serif text-2xl font-medium text-magenta" data-id="element-118">
              Terapia T.P.V.
            </h3>
            <p className="text-sm text-muted leading-relaxed" data-id="element-119">
              Simona Popa
              <br data-id="element-120" />
              Life Coach & Terapeut în Vindecare Emoțională
            </p>
          </div>

          {/* Legal Links */}
          <div className="space-y-4" data-id="element-121">
            <h4 className="text-xs font-medium tracking-widest uppercase text-navy" data-id="element-122">
              Informații Legale
            </h4>
            <ul className="space-y-2" data-id="element-123">
              {legalLinks.map((link, index) => <li key={index} data-id="element-124">
                  <a href="#" className="text-sm text-muted hover:text-magenta transition-colors" data-id="element-125">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Social Media */}
          <div className="space-y-4" data-id="element-126">
            <h4 className="text-xs font-medium tracking-widest uppercase text-navy" data-id="element-127">
              Conectează-te
            </h4>
            <div className="flex gap-4" data-id="element-128">
              <a href="https://www.facebook.com/simonacosmina.popa.3" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-magenta transition-colors" data-id="element-129">
                <Facebook className="w-6 h-6" strokeWidth={1.5} data-id="element-130" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-cardBorder text-center" data-id="element-131">
          <p className="text-sm text-muted" data-id="element-132">
            © 2026 Simona Popa. Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>;
}